module.exports = "/images/magnifier-icon.svg?0bb4b31e7d49bc90f47e515e6ef21d56";